import { formatTime } from './../../../common/commonHelper';
import { columns, stack } from 'ngx-bootstrap-icons';
import { Component, Injectable, OnInit } from '@angular/core';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfFonts1 from './../../../../assets/fonts/vfs_fonts';
import { fonts } from '../../../config/pdfFonts';
import { CompanyService } from '../../../services/company.service';
import { AttachmentsService } from '../../../services/attachments.service';
import * as moment from 'moment';
import { formatStringTime, getCurrency } from '../../../common/commonHelper';
import htmlToPdfmake from 'html-to-pdfmake';
import  DOMPurify from 'dompurify';
import { HttpClient } from '@angular/common/http';
import { COST_GROUP } from '../../../model/constant';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = fonts;
@Injectable({
  providedIn: "root",
})
@Component({
  selector: 'app-generate-pdf',
  templateUrl: './generate-pdf.component.html',
  styleUrls: ['./generate-pdf.component.scss']
})
export class GeneratePdfComponent implements OnInit {
  pdfImageDataUrl: string | undefined;
  imageDataUrl: string | undefined;
  logoUrl: string | undefined;
  InvoiceCustomStyle = {
    bold: "semiBold",
    fontSize: 10,
    alignment: 'left',
    color: 'white',
    fillColor: '#ff0000',
  };
  tableLayout = {
    hLineWidth: function (i, node) {
      return 1;
    },
    vLineWidth: function (i, node) {
      return 0;
    },
    vLineColor: function (i, node) {
      if (i === 0 || i === node.table.body.length) {
        return '#e5e5e5'; // Color for top and bottom borders
      } else {
        return '#e5e5e5'; // Regular color for internal rows
      }
    },
    hLineColor: function (i, node) {
      if (i === 0 || i === node.table.body.length) {
        return '#e5e5e5'; // Color for top and bottom borders
      } else {
        return '#e5e5e5'; // Regular color for internal rows
      }
    },
    paddingTop: function (i, node) {
      if (i === 0) {
        return 5; // Add padding to the top of all cells
      } else {
        return 15
      }
    },
    paddingBottom: function (i, node) {
      if (i === 0) {
        return 5; // Add padding to the bottom of the last row for the border
      } else {
        return 15; // Regular padding for internal rows
      }
    },
    paddingLeft: function (i, node) {
      return 10;
    },
    fillColor: function (i, node, columnIndex) {
      if (i === 0) {
        return '#ff0000';
      } else {
        return '#fff'; // Regular padding for internal rows
      }
    },
    fillOpacity: function (i, node, columnIndex) {
      if (i != 0) {
        return 0
      }
    },
    marginTop: function (i, currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
      // Add a margin of 50 units if the table spans to the next page
      if (followingNodesOnPage.length === 0 && nodesOnNextPage.length > 0) {
        return 100;
      }
    },
    pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
      // Check if the table goes onto the next page
      if (followingNodesOnPage.length === 0 && nodesOnNextPage.length > 0) {
        console.log("Table goes onto next page!");
        return true; // Add a page break before the table
      }
      return false;
    }
  }
  companyName: string = "";
  companyAddress: string = "";
  constructor(private _companyService: CompanyService,
    private _attachmentService: AttachmentsService,
    private http: HttpClient) { }

  ngOnInit(): void {
  }
  setPdfData(fileName) {
    console.log("File Name is ", fileName);

    // Get company details and store company logo
    this._companyService.getCompanyDetails().subscribe((data) => {
      console.log("Company details are ", data);
      this.companyName = data?.result?.name || '';
      this.companyAddress = data?.result?.address?.fullAddress || '';
      const company = localStorage.getItem('selectedCompany');
      console.log("Company is ", company);
      this._attachmentService.ImageRead(company, 'Company', fileName).then((imageBuffer) => {
        /* if (imageBuffer && imageBuffer.byteLength > 0) {
          // Convert image buffer to base64
          const base64Image = btoa(String.fromCharCode(...new Uint8Array(imageBuffer)));
          this.imageDataUrl = `data:image/png;base64,${base64Image}`;

          // Store the base64 image in localStorage
          localStorage.setItem("companyLogo", this.imageDataUrl);
        } else {
          console.log("Invalid image buffer for company logo.");
        } */
         if (imageBuffer && imageBuffer.byteLength > 0) {
          const blob = new Blob([new Uint8Array(imageBuffer)], { type: 'image/png' });
          const reader = new FileReader();

          reader.onload = () => {
            this.imageDataUrl = reader.result as string;
            localStorage.setItem("companyLogo", this.imageDataUrl);
          };

          reader.onerror = (e) => {
            console.log("Error reading blob as data URL:", e);
          };

          reader.readAsDataURL(blob);
        } else {
          console.log("Invalid image buffer for company logo.");
        }
      }).catch(err => {
        console.log("Error reading company image:", err);
      });
      if(data?.result?.rtsImage?.fileName){
        this.setRTSImage(data?.result, data?.result?.rtsImage?.fileName);
      }
      else{
        localStorage.removeItem("rtsImage");
      }
    });

    // Read PDF image data
    this._attachmentService.PdfImageRead().then((imageBuffer) => {
      if (imageBuffer && imageBuffer.byteLength > 0) {
        // Convert image buffer to base64
        const base64Image = btoa(String.fromCharCode(...new Uint8Array(imageBuffer)));
        this.pdfImageDataUrl = `data:image/png;base64,${base64Image}`;

        // Store the base64 image in localStorage
        localStorage.setItem("pdfImage", this.pdfImageDataUrl);
      } else {
        console.error("Invalid image buffer for PDF background image.");
      }
    }).catch(err => {
      console.error("Error reading PDF background image:", err);
    });
  }

  setRTSImage(company, fileName) {
    this._attachmentService.ImageRead(company, 'FactorImage', fileName).then((imageBuffer) => {
      if (imageBuffer && imageBuffer.byteLength > 0) {
        // Convert image buffer to base64
        const base64Image = btoa(String.fromCharCode(...new Uint8Array(imageBuffer)));
        const rtsFactorImage = `data:image/png;base64,${base64Image}`;

        // Store the base64 image in localStorage
        localStorage.setItem("rtsImage", rtsFactorImage);
      } else {
        console.log("Invalid Factor image for company.");
      }
    }).catch(err => {
      console.log("Error reading company image:", err);
    });
  }
  getFooterData(companyName, companyAddress, email='') {
    return {
      columns: [
        {
          alignment: 'center',
          width: '40%',
          margin:[20,0,0,0],
          fillColor: '#ff0000',
          text: email?'For any queries or feedback, please contact us at '+email+'.':''

        },
        {},
        localStorage.getItem('companyLogo') ?
          {
            alignment: 'right',
            width: '30%',
            fillColor: '#ff0000',
            text: [
              {
                text: "Powered by " + "\n",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
                fillColor: '#ff0000',
              },
              {
                text: "LOADMILES",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
                fillColor: '#ff0000',
                link: "http://www.loadmiles.com"
              }
            ],
          } : {
            alignment: 'right',
            width: '30%',
            fillColor: '#ff0000',
            margin: [0, 0, 10, 0],
            text: [
              {
                text: "Powered by " + "\n",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
                fillColor: '#ff0000',
              },
              {
                text: "LOADMILES",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
                fillColor: '#ff0000',
                link: "http://www.loadmiles.com"
              }
            ],
          }
      ]
    }
  }
  /* getHeaderData(companyName, companyAddress, title) {
    return {
      columns: [
        {
          stack: [
            localStorage.getItem('companyLogo') ?
              {
                columns: [
                  {
                    image: localStorage.getItem('companyLogo'),
                    width: 80,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: title,
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  }
                ]
              } :
              {
                columns: [
                  {
                    alignment: 'left',
                    width: 180,
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 11,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                  {
                    text: 'INVOICE',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  }
                ]
              }
          ]
        }
      ]
    }
  } */
  getHeaderData(companyName, companyAddress, title?) {
    return {
      columns: [
        {
          stack: [
            localStorage.getItem('companyLogo') ?
              {
                columns: [
                  {
                    image: localStorage.getItem('companyLogo'),
                    width: 85,
                    alignment: 'left',
                    margin: [10, 0, 0, 0],
                  },
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 180,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              } :
              {
                columns: [
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 200,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              }
          ]
        }
      ]
    }
  }
  getDispatchHeaderData(title?) {
    return {
      columns: [
        {
          stack: [
            localStorage.getItem('companyLogo') ?
              {
                columns: [
                  {
                    image: localStorage.getItem('companyLogo'),
                    width: 80,
                    alignment: 'left',
                    margin: [20, 0, 0, 0],
                  },
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 180,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: this.companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: this.companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              } :
              {
                columns: [
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 200,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: this.companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: this.companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              }
          ]
        }
      ]
    }
  }
  getRateconHeaderData(companyName, companyAddress, title?) {
    return {
      columns: [
        {
          stack: [
            localStorage.getItem('companyLogo') ?
              {
                columns: [
                  {
                    image: localStorage.getItem('companyLogo'),
                    width: 80,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 180,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              } :
              {
                columns: [
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'right',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'right',
                    width: 200,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              }
          ]
        }
      ]
    }
  }
  getHeader3(title, materialTotal, truckingTotal) {
    let table: any[] =
      [
        [
          {
            text: 'Summary',
            bold: true,
            border: [false, false, false, false],
            margin: [0, 5, 0, 5],
            alignment: 'center',
            color:'white',
            fillColor: '#ff0000',
            colSpan: 2
          }, {}
        ],
        [
          {
            text: `Material Total:`,
            fontSize: 12,
            bold: true,
            alignment: 'left',
            border: [false, false, false, false],
            margin: [0, 5, 0, 5],
          },
          {
            text: getCurrency(materialTotal || 0),
            fontSize: 12,
            alignment: 'right',
            border: [false, false, false, false],
            margin: [0, 5, 0, 5],
          },
        ],
        [
          {
            text: `Trucking Total:`,
            fontSize: 12,
            bold: true,
            alignment: 'left',
            border: [false, false, false, false],
            margin: [0, 5, 0, 5],
          },
          {
            text: getCurrency(truckingTotal || 0),
            fontSize: 12,
            alignment: 'right',
            border: [false, false, false, false],
            margin: [0, 5, 0, 5],
          }
        ]
      ]

    let data =
    {
      columns: [
        {},
        {
          table: {
            headerRows: 1,
            widths: '*',
            body: table
          }
        }
      ],
      unbreakable: true
    }

    return data

    // return {
    //   columns: [
    //     {},
    //     {
    //       alignment: 'left',
    //       margin: [0, 15, 0, 0],
    //       fillColor: '#ff0000',
    //       text: [
    //         {
    //           text: `${title}`,
    //           bold: true,
    //           fontSize: 10,
    //           alignment: 'center',
    //           color: 'Black',
    //           border: [false, false, false, false],
    //           margin: [10, 5, 0, 5],
    //         }
    //       ]
    //     }
    //   ]
    // }
  }
  getHeader2(title, invoiceNumber, invoiceDate, isJOb, titleSize=28) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                  text: title.toUpperCase(),
                  width: '*',
                  fontSize: titleSize,
                  alignment: 'left',
                  font: 'MyriadPro',
                  margin: [0, 15, 0, 0],

                },
                {
                  alignment: 'right',
                  margin: [0, 15, 0, 0],
                  table: {
                    headerRows: 1,
                    widths: ['auto', '*'],
                    body: [
                      [
                        {
                          text: invoiceNumber ? isJOb + ' # ' + invoiceNumber : '',
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [10, 5, 0, 5],
                        },
                        {
                          text: 'Date ' + moment(invoiceDate).format("MM/DD/YYYY"),
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                    ],
                  },
                }
              ]
            }
          ]
        }
      ]
    }
  }
  getShippingInfo(invoiceToTitle, name, address) {
    return {
      columns: [
        {
          text: [
            // {
            //   text: invoiceToTitle + " to: " + "\n",
            //   width: '*',
            //   fontSize: 12,
            //   font: "Poppins",
            //   alignment: 'left',
            // },
            {
              text: name ? name + "\n" : '' + "\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            },
            {
              text: address ? address : '',
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            },
          ]
        },
        {

        }
      ]

    }
  }

  // Get Pickup & Dropoff Address
  getPickupDropoffAddress(pickupAddress, dropoffAddress) {
    return {
      columns: [
        {
          text: [
            {
              text: "Pickup: " + "\n",
              width: '*',
              fontSize: 12,
              bold: true,
              font: "Poppins",
              alignment: 'left',
            },
            {
              text: pickupAddress ? pickupAddress + "\n" : '' + "\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            }
          ],
          alignment: 'left',
        },
        {
          text: [
            {
              text: "Delivery: " + "\n",
              width: '*',
              fontSize: 12,
              bold: true,
              font: "Poppins",
              alignment: 'left',
            },
            {
              text: dropoffAddress ? dropoffAddress + "\n" : '' + "\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            }
          ],
          alignment: 'right',
        }
      ]

    }
  }
  getPickupDropoffRateconDetails(pickupList, dropoffList) {
    let pickupPDFList = []
    let dropoffPDFList = []
    pickupList.forEach((element, index) => {
      pickupPDFList.push({
        text: "Pickup " + (index + 1) + " : " + "\n",
        width: '*',
        fontSize: 12,
        bold: true,
        font: "Poppins",
        alignment: 'left',
      },
        {
          text: element?.address?.fullAddress ? element?.address?.fullAddress + "\n" : '' + "\n",
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Pickup Date : ",
            width: 50,
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: moment(element.pickupDate).format("MM/DD/YYYY") + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Pickup Time : ",
            width: '*',
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: formatStringTime(element.pickupTime) + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Pickup Reference : ",
            width: 50,
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: element.pickupRef + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Pickup Instructions : ",
            width: 50,
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: element.comment||'' + "\n\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
      )
    });

    dropoffList.forEach((element, index) => {
      dropoffPDFList.push({
        text: "Delivery " + (index + 1) + " : " + "\n",
        width: '*',
        fontSize: 12,
        bold: true,
        font: "Poppins",
        alignment: 'left',
      },
        {
          text: element?.dropAddress?.fullAddress ? element?.dropAddress?.fullAddress + "\n" : '' + "\n",
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Delivery Date : ",
            width: '*',
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: moment(element.dropoffDate).format("MM/DD/YYYY") + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [{
            text: "Delivery Time : ",
            width: '*',
            fontSize: 12,
            bold: true,
            font: "Poppins",
            alignment: 'left',
          }, {
            text: formatStringTime(element.dropoffTime) + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [
            {
              text: "Delivery Reference : ",
              width: '*',
              fontSize: 12,
              bold: true,
              font: "Poppins",
              alignment: 'left',
            }, {
              text: element.dropoffRef + "\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
        {
          text: [
            {
              text: "Delivery Instructions : ",
              width: '*',
              fontSize: 12,
              bold: true,
              font: "Poppins",
              alignment: 'left',
            }, {
              text: element.comment||'' + "\n\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            }],
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },)
    });
    return {
      columns: [
        {
          text: pickupPDFList,
          alignment: 'left',
        },
        {
          text: dropoffPDFList,
          alignment: 'right',
        }
      ]

    }
  }
  getPickupDropoffRateconDetails2(pickDropList) {
    let dropoffPDFList = []

    pickDropList.forEach((element) => {
      dropoffPDFList.push({ canvas: [{ type: 'line', x1: 0, y1: 10, x2: 530, y2: 10, lineWidth: 0.5 }] })
      if (element.type == "pickup") {
        dropoffPDFList.push(
          {
            columns: [
              {
                text: [
                  {
                    text: "\n Carrier : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  },
                  {
                    text: element?.carrier?.companyname || 'N/A' + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  },
                ],
              },
              {
                text: [
                  {
                    text: "\n Driver : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  },
                  {
                    text: element?.driver1?.fullName || 'N/A' + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  },
                ],
              },
            ],
          },
          {
          text: "Pickup " + (element.index) + " : " + "\n",
          width: '*',
          fontSize: 12,
          bold: true,
          font: "Poppins",
          alignment: 'left',
        },
          {
            text: element?.address?.fullAddress + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },
          {
            columns: [
              {
                text: [
                  {
                    text: "Pickup Company : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  }, {
                    text: element?.pickupCompany + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
            ]
          },
          {
            columns: [
              {
                text: [
                  {
                    text: "Pickup Date : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  }, {
                    text: moment(element.pickupDateTime).format("MM/DD/YYYY") + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
              {
                text: [{
                  text: "Pickup Time : ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left',
                }, {
                  text: formatStringTime(element.pickupTime) + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left',
                }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
            ]
          },
          {
            text: [
              {
                text: "Pickup Reference : ",
                width: '*',
                fontSize: 12,
                bold: true,
                font: "Poppins",
                alignment: 'left',
              }, {
                text: element.pickupRef + "\n",
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              }],
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },
          {
            text: [{
              text: "Pickup Instructions : ",
              width: 50,
              fontSize: 12,
              bold: true,
              font: "Poppins",
              alignment: 'left',
            }, {
              text: element.comment||'' + "\n\n",
              width: '*',
              fontSize: 12,
              font: "Poppins",
              alignment: 'left',
            }],
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },)
      }
      else {
        dropoffPDFList.push(
          {
            columns: [
              {
                text: [
                  {
                    text: "\n Carrier : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  },
                  {
                    text: element?.carrier?.companyname || 'N/A' + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  },
                ],
              },
              {
                text: [
                  {
                    text: "\n Driver : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  },
                  {
                    text: element?.driver1?.fullName || 'N/A' + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  },
                ],
              },
            ],
          },
          {
          text: "Delivery " + (element.index) + " : " + "\n",
          width: '*',
          fontSize: 12,
          bold: true,
          font: "Poppins",
          alignment: 'left',
        },
          {
            text: element?.dropAddress?.fullAddress + "\n",
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },
          {
            columns: [
              {
                text: [
                  {
                    text: "Delivery Company : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  }, {
                    text: element?.dropCompany + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
            ]
          },
          {
            columns: [
              {
                text: [
                  {
                    text: "Delivery Date : ",
                    width: '*',
                    fontSize: 12,
                    bold: true,
                    font: "Poppins",
                    alignment: 'left',
                  }, {
                    text: moment(element.dropoffDateTime).format("MM/DD/YYYY") + "\n",
                    width: '*',
                    fontSize: 12,
                    font: "Poppins",
                    alignment: 'left',
                  }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
              {
                text: [{
                  text: "Delivery Time : ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left',
                }, {
                  text: formatStringTime(element.dropoffTime) + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left',
                }],
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              },
            ]
          },

          {
            text: [
              {
                text: "Delivery Reference : ",
                width: '*',
                fontSize: 12,
                bold: true,
                font: "Poppins",
                alignment: 'left',
              }, {
                text: element.dropoffRef + "\n",
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              }],
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },
          {
            text: [
              {
                text: "Delivery Instructions : ",
                width: '*',
                fontSize: 12,
                bold: true,
                font: "Poppins",
                alignment: 'left',
              }, {
                text: element.comment||'' + "\n\n",
                width: '*',
                fontSize: 12,
                font: "Poppins",
                alignment: 'left',
              }],
            width: '*',
            fontSize: 12,
            font: "Poppins",
            alignment: 'left',
          },)
      }
    })
      ;
    return {
      stack: [
        // {
        //   text:
        dropoffPDFList,
        //   alignment: 'right',
        // }
      ]

    }
  }
  getSurchargePart(percent: number, fuelSurcharge: number) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                },
                {
                  table: {
                    headerRows: 1,
                    widths: ['60%', '40%'],
                    body: [
                      [
                        {
                          text: `Fuel Surcharge (${percent || 0}%):`,
                          fontSize: 12,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(fuelSurcharge || 0),
                          fontSize: 12,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ]
                    ],
                  },
                  layout: {
                    vLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                    hLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                  }
                }
              ]
            }
          ]
        }
      ]

    }
  }

  getSummaryPart(total) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                },
                {

                },
                {
                  table: {
                    headerRows: 1,
                    widths: ['*', '*'],
                    body: [
                      /* [
                        {
                          text: 'Sub Total:',
                          fontSize: 10,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: '$' + total.toLocaleString(2),
                          fontSize: 10,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                      [
                        {
                          text: 'Tax:',
                          fontSize: 10,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: '0.0%',
                          fontSize: 10,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ], */
                      [
                        {
                          text: 'Total:',
                          fontSize: 12,
                          bold:true,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(total),
                          fontSize: 12,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ]
                    ],
                  },
                  layout: {
                    vLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                    hLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                  }
                }
              ]
            }
          ]
        }
      ]

    }
  }
  getAdditionalInfo(additionalInfo) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                },
                {
                  table: {
                    headerRows: 1,
                    widths: ['*', '*'],
                    body: [
                      [
                        {
                          text: 'Bank Charge:',
                          fontSize: 10,
                          bold:false,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(additionalInfo?.bankCharge || 0),
                          fontSize: 10,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                      [
                        {
                          text: 'Discount:',
                          fontSize: 10,
                          bold:false,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(additionalInfo?.discount || 0),
                          fontSize: 10,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                      [
                        {
                          text: 'Rounding:',
                          fontSize: 10,
                          bold:false,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(additionalInfo?.rounding || 0),
                          fontSize: 10,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                    ],
                  },
                  layout: {
                    vLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                    hLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                  }
                }
              ]
            }
          ]
        }
      ]

    }
  }
  getRateconCommentsPart(comments) {
    return {
      text: [
        {
          text: 'Comments:' + "\n",
          width: '*',
          fontSize: 12,
          font: "Poppins",
          bold: true,
          alignment: 'left',
        },
        {
          text: comments ? comments : '',
          width: '*',
          fontSize: 12,
          font: "Poppins",
          alignment: 'left',
        },
      ]
    }
  }
  async generatePDF(pdfData, preview = true) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, subTotal = 0, tax, surcharge = 0, invoiceType = 'Job No' } = pdfData;
    let isInv = pdfData.isjobInv;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const shippingInfo = this.getShippingInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress);
    // const consinee = this.consignJobInvSection()
    const surchargeAmount = total * surcharge / 100;
    const surChargeData = invoiceType === 'Job No' ? this.getSurchargePart(surcharge, surchargeAmount) : null;
    const summaryData = this.getSummaryPart(total + surchargeAmount);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    console.log(localStorage.getItem('pdfImage'));
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,


        },

        "\n\n",

        surChargeData,

        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},
      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(summaryData)
    }
    if (preview) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }
  /* generatePDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, subTotal = 0, tax } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const docDefinition = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        {
          columns: [
            {
              stack: [
                {
                  columns: [
                    {

                    },
                    {
                      table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: [
                          [
                            {
                              text: 'Invoice: # ' + invoiceHeader?.invoiceId ?? '',
                              style: this.InvoiceCustomStyle,
                              border: [false, false, false, false],
                              margin: [10, 5, 0, 5],
                            },
                            {
                              text: 'Date ' + moment(invoiceHeader.invoiceDate).format("MM/DD/YYYY"),
                              style: this.InvoiceCustomStyle,
                              border: [false, false, false, false],
                              margin: [0, 5, 10, 5],
                            },
                          ],
                        ],
                      },
                    }
                  ]
                }
              ]
            }
          ]
        },
        "\n",
        {
          columns: [
            {
              text: [
                {
                  text: "Invoice to: " + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left',
                },
                {
                  text: invoiceHeader.customerName ? invoiceHeader.customerName : '' + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left',
                },
                {
                  text: "\n" + invoiceHeader.customerAddress ? invoiceHeader.customerAddress : '',
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left',
                },
              ]
            },
            {

             }
           ]

         },
         "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,


         },
         "\n\n",
         {
           columns: [
             {
               stack: [
                 {
                   columns: [
                     {

                     },
                     {

                    },
                    {
                      table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: [
                          [
                            {
                              text: 'Sub Total:',
                              fontSize: 10,
                              alignment: 'left',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                            {
                              text: '$' + total.toLocaleString(2),
                              fontSize: 10,
                              alignment: 'right',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                          ],
                          [
                            {
                              text: 'Tax:',
                              fontSize: 10,
                              alignment: 'left',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                            {
                              text: '0.0%',
                              fontSize: 10,
                              alignment: 'right',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                          ],
                          [
                            {
                              text: 'Total:',
                              fontSize: 10,
                              alignment: 'left',
                              border: [false, true, false, false],
                              margin: [0, 5, 0, 5],
                            },
                            {
                              text: '$' + total.toLocaleString(2),
                              fontSize: 10,
                              alignment: 'right',
                              border: [false, true, false, false],
                              margin: [0, 5, 0, 5],
                            },
                          ]
                        ],
                      },
                      layout: {
                        vLineColor: function (i, node) {
                          if (i === node.table.body.length) {
                            return '#e5e5e5'; // Color for top and bottom borders
                          }
                        },
                        hLineColor: function (i, node) {
                          if (i === node.table.body.length) {
                            return '#e5e5e5'; // Color for top and bottom borders
                          }
                        },
                      }
                    }
                  ]
                }
              ]
            }
          ]

        },
      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };

    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
  } */
  generateBillPDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, bill = "", invoiceType = "Invoice" } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2(bill, invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const shippingInfo = this.getShippingInfo("Bill", invoiceHeader.vendorName, invoiceHeader.vendorAddress);
    const summaryData = this.getSummaryPart(total);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout


        },
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},

      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins", // Use the font family name you defined
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(summaryData)
    }
    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
  }
  /*  generateBillPDF(pdfData) {
     const { invoiceHeader, invoiceItemsData, widths, total = 0, bill = "" } = pdfData;
     const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress);
     const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress, bill);
     const docDefinition = {
       content: [
         {
           image: localStorage.getItem('pdfImage'), // Replace with your background image URL
           width: 595, // Adjust the width to match your page size
           height: 842, // Adjust the height to match your page size
           absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
         },
         headerData,
         '\n\n',
         {
           columns: [
             {
               stack: [
                 {
                   columns: [
                     {

                     },
                     {
                       table: {
                         headerRows: 1,
                         widths: ['*', '*'],
                         body: [
                           [
                             {
                               text: 'Invoice # ' + invoiceHeader?.invoiceId ?? '',
                               style: this.InvoiceCustomStyle,
                               border: [false, false, false, false],
                               margin: [10, 5, 0, 5],
                             },
                             {
                               text: 'Date ' + moment(invoiceHeader.invoiceDate).format("MM/DD/YYYY"),
                               style: this.InvoiceCustomStyle,
                               border: [false, false, false, false],
                               margin: [0, 5, 10, 5],
                             },
                           ],
                         ],
                       },
                     }
                   ]
                 }
               ]
             }
           ]
         },
         "\n",
         {
           columns: [
             {
               text: [
                 {
                   text: "Bill to: " + "\n",
                   width: '*',
                   fontSize: 12,
                   font: "Poppins",
                   alignment: 'left',
                 },
                 {
                   text: invoiceHeader.vendorName ? invoiceHeader.vendorName : '' + "\n",
                   width: '*',
                   fontSize: 12,
                   font: "Poppins",
                   alignment: 'left',
                 },
                 {
                   text: "\n" + invoiceHeader.vendorAddress ? invoiceHeader.vendorAddress : '',
                   width: '*',
                   fontSize: 12,
                   font: "Poppins",
                   alignment: 'left',
                 },
               ]
             },
             {

             }
           ]

         },
         "\n",

         {
           table: {
             headerRows: 1,
             widths: widths,
             body: invoiceItemsData,
           },
           layout: this.tableLayout


         },
         "\n\n",
         {
           columns: [
             {
               stack: [
                 {
                   columns: [
                     {

                     },
                     {

                     },
                     {
                       table: {
                         headerRows: 1,
                         widths: ['*', '*'],
                         body: [
                           [
                             {
                               text: 'Sub Total:',
                               fontSize: 10,
                               alignment: 'left',
                               border: [false, false, false, false],
                               margin: [0, 5, 0, 5],
                             },
                             {
                               text: '$' + total.toLocaleString(2),
                               fontSize: 10,
                               alignment: 'right',
                               border: [false, false, false, false],
                               margin: [0, 5, 0, 5],
                             },
                           ],
                           [
                             {
                               text: 'Tax:',
                               fontSize: 10,
                               alignment: 'left',
                               border: [false, false, false, false],
                               margin: [0, 5, 0, 5],
                             },
                             {
                               text: '0.0%',
                               fontSize: 10,
                               alignment: 'right',
                               border: [false, false, false, false],
                               margin: [0, 5, 0, 5],
                             },
                           ],
                           [
                             {
                               text: 'Total:',
                               fontSize: 10,
                               alignment: 'left',
                               border: [false, true, false, false],
                               margin: [0, 5, 0, 5],
                             },
                             {
                               text: '$' + total.toLocaleString(2),
                               fontSize: 10,
                               alignment: 'right',
                               border: [false, true, false, false],
                               margin: [0, 5, 0, 5],
                             },
                           ]
                         ],
                       },
                       layout: {
                         vLineColor: function (i, node) {
                           if (i === node.table.body.length) {
                             return '#e5e5e5'; // Color for top and bottom borders
                           }
                         },
                         hLineColor: function (i, node) {
                           if (i === node.table.body.length) {
                             return '#e5e5e5'; // Color for top and bottom borders
                           }
                         },
                       }
                     }
                   ]
                 }
               ]
             }
           ]

         },

       ],
       pageMargins: [40, 20, 40, 60],
       footer: footerData,
       defaultStyle: {
         font: "Poppins", // Use the font family name you defined
       },
     };

     pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
   } */
  generatePaymentPDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, bill = "Receipt", paymentType = 'Job No' } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2(bill, invoiceHeader.invoiceId, invoiceHeader.paymentDate ? invoiceHeader.paymentDate : invoiceHeader.createdAt, paymentType);
    const shippingInfo = this.getShippingInfo("Payment", invoiceHeader.name, invoiceHeader.vendorAddress);
    const summaryData = this.getSummaryPart(total);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout


        },
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},

      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(summaryData)
    }
    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
  }
  generateReceiptPDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, bill = "Receipt", invoiceType = 'Job No', additionalInfo = null } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2(bill, invoiceHeader.invoiceId, invoiceHeader.paymentDate ? invoiceHeader.paymentDate : invoiceHeader.createdAt, invoiceType);
    const shippingInfo = this.getShippingInfo("Payment", invoiceHeader.customer, invoiceHeader.customerAddress);
    const summaryData = this.getSummaryPart(total);
    const additionalData = this.getAdditionalInfo(additionalInfo);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout


        },
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? additionalData : {},
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},

      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(additionalData)
      // docDefinition.content.push(summaryData)
    }
    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
  }
  generateJobPDF(pdfData) {

    console.log(pdfData);

    const { invoiceHeader, invoiceItemsData, widths, total = 0, terms ,bill = "Invoice No" } = pdfData;
    const { pickupAddress, dropoffAddress, surcharge } = invoiceHeader;
    console.log({ pickupAddress, dropoffAddress, surcharge });
    let cleanText = DOMPurify.sanitize(terms)
    let htmlText = htmlToPdfmake(cleanText)
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);

    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);

    const header2 = this.getHeader2("ESTIMATE", invoiceHeader.jobNumber, invoiceHeader.createdAt, bill);

    const shippingInfo = this.getShippingInfo("Estimate", invoiceHeader.customer, invoiceHeader.customerAddress);

    // const pickupDropoffInfo = this.getPickupDropoffAddress(pickupAddress, dropoffAddress);

    const surchargeAmount = total * surcharge / 100;
    const surChargeData = this.getSurchargePart(surcharge, surchargeAmount);

    const summaryData = this.getSummaryPart(total + surchargeAmount);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      header: headerData,
      content: [

        '\n\n',

        header2,

        "\n",

        shippingInfo,

        // "\n",

        // pickupDropoffInfo,




        {

          table: {

            headerRows: 1,

            widths: widths,
            body: invoiceItemsData.slice(0, lineItemStart),
          },

          layout: this.tableLayout





        },

        "\n\n",

        // surChargeData,

        // "\n\n",

        summaryData,


        "\n\n",

        htmlText,


      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],

      footer: footerData,

      defaultStyle: {

        font: "Poppins",

        fontSize: 10,

      },

    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",

        );
      }
      docDefinition.content.push(summaryData)
    }



    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();

  }


  async generateRateconPDF(pdfData, preview, TnC?: any) {

    console.log(pdfData);

    const { loadDetails, customer, widths, price, total = 0, rateQualifer, rate } = pdfData;
    // const { pickupAddress, dropoffAddress, surcharge } = invoiceHeader;
    // console.log({ pickupAddress, dropoffAddress, surcharge });
    let invoiceItemsData: any[][] = [
      [
        {
          text: 'Load #',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Customer Ref',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Shipper Ref',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Description',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Amount',
          border: [false, true, false, true],
          alignment: 'right',
          fillColor: '#eaf2f5',
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
      ]]
    let obj: any = {};
    obj["loadNumber"] = loadDetails.loadNumber;
    obj["crefNo"] = loadDetails.crefNo;
    obj["srefNo"] = loadDetails.srefNo;
    obj["Description"] = loadDetails.Description

    let columnsObj = [
      { text: loadDetails?.loadNumber, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
      { text: loadDetails?.crefNo, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
      { text: loadDetails?.srefNo, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
      { text: loadDetails?.notes === undefined ? '-' : loadDetails?.notes, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
      { text: loadDetails?.loadPrice, border: [false, false, false, true], fillColor: '#f5f5f5', alignment: 'right', margin: [0, 5, 0, 5] }]
    invoiceItemsData.push(columnsObj);
    let pickDrop = [];
    let pickupsize = 0
    let dropsize = 0
    loadDetails.pickupinfo.forEach(element => {
      element['type'] = 'pickup'
      element['sortTime'] = element?.pickupDateTime;
      pickupsize++;
      element['index'] = pickupsize;
      pickDrop.push(element);
    });
    loadDetails.dropoffinfo.forEach(element => {
      element['type'] = 'dropoff'
      element['sortTime'] = element?.dropoffDateTime;
      dropsize++;
      element['index'] = dropsize;
      pickDrop.push(element);
    });
    // pickDrop.some
    pickDrop.sort((a, b) => new Date(a.sortTime) > new Date(b.sortTime) ? 1 : -1);
    let selectedCompanyId = localStorage.getItem('selectedCompany');

    let companyList = JSON.parse(sessionStorage.getItem('LOGIN_USER')).result[0].company

    let currentCompanyDetail = companyList.filter((company) => { return company?.company?._id == selectedCompanyId })[0].company;

    const footerData = this.getFooterData(currentCompanyDetail.name, loadDetails.companyAddress, currentCompanyDetail.email);

    const headerData = this.getRateconHeaderData(currentCompanyDetail.name, currentCompanyDetail.address.fullAddress);

    const header2 = this.getHeader2("LOAD CONFIRMATION", loadDetails.loadNumber, loadDetails.createdAt, "Load No");

    const shippingInfo = this.getShippingInfo("Estimate", customer?.name, customer?.BillingAddress?.fullAddress | customer?.CustomerAddress?.fullAddress);
    let equipType
    if (loadDetails?.equipType == 0) {
      equipType = "Dry Van"
    } else if (loadDetails?.equipType == 1) {
      equipType = "Reefer"
    } else if (loadDetails?.equipType == 2) {
      equipType = "Flatbed"
    } else if (loadDetails?.equipType == 3) {
      equipType = "Stepdeck"
    } else if (loadDetails?.equipType == 4) {
      equipType = "Special"
    }
    else {
      equipType = ""
    }
    const shipperDetails = this.shipperDetails(obj?.srefNo, loadDetails?.commodity, loadDetails?.weight, equipType, rate, loadDetails?.loadPrice, total, customer?.paymentTerms, rateQualifer, loadDetails.distance, loadDetails?.loadCost);
    // const pickupDropoffInfo = this.getPickupDropoffRateconDetails(loadDetails.pickupinfo, loadDetails.dropoffinfo);
    const pickupDropoffInfo = this.getPickupDropoffRateconDetails2(pickDrop);
    let carrer:any  = ''
    /* if(loadDetails.pickupinfo[0]?.carrier){
      carrer = {
        stack: [
          {
            columns: [
              {
                text: "Carrier: ",
                width: '25%',
                fontSize: 16,
                bold: true,
                font: "Poppins",
                alignment: 'left'
              },
              {
                text: loadDetails.pickupinfo[0]?.carrier?.companyname ?  loadDetails.pickupinfo[0]?.carrier?.companyname  + "\n\n" : "" + "\n\n",
                width: '*',
                fontSize: 16,
                bold: true,
                font: "Poppins",
                alignment: 'left'
              }
            ]
          }]
      }
    }
    else{
      if(loadDetails.pickupinfo[0]?.driver1){
        carrer = {
          stack: [
            {
              columns: [
                {
                  text: "Driver: ",
                  width: '25%',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: loadDetails.pickupinfo[0]?.driver1?.fullName ? loadDetails.pickupinfo[0]?.driver1?.fullName + "\n" : "" + "\n" ,
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            }]
        }
      }
    } */

    // const surchargeAmount = total * surcharge / 100;
    // const surChargeData = this.getSurchargePart(surcharge, surchargeAmount) || '';

    const summaryData = loadDetails.comments ? this.getRateconCommentsPart(loadDetails.comments) : "";
    let itemsPerPage = 6;
    let lineItemStart = 6;
    let cleanText = DOMPurify.sanitize(TnC)
    let htmlText = htmlToPdfmake(cleanText)
    const docDefinition: any = {
      content: [

        {

          image: localStorage.getItem('pdfImage'), // Replace with your background image URL

          width: 595, // Adjust the width to match your page size

          height: 842, // Adjust the height to match your page size

          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

        },
        headerData,
        '\n\n',
        header2,
        "\n",
        carrer,
        shipperDetails,
        "\n",
        pickupDropoffInfo,
        "\n",
        // {
        //   table: {
        //     headerRows: 1,
        //     widths: widths,
        //     body: invoiceItemsData,
        //   },
        //   layout: this.tableLayout
        // },
        // "\n\n",
        // surChargeData,
        "\n\n",
        summaryData,
        {
          text: htmlText,
          alignment: 'center',
        }
      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10,
      },
    };

    if (preview == true) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }

  shipperDetails(shipref = "", commodity = "", weight = "", EqType = "", rate = "", price = "", total = "", terms = "", rateQualifer = "", distance = "", loadCost = "") {

    shipref = shipref ? shipref : "";
    commodity = commodity ? commodity : "";
    weight = weight ? weight : "";
    EqType = EqType ? EqType : "";
    rate = rate ? rate : "";
    distance = distance ? distance : "0.00";
    price = "$" + (price ? price : "0.00");
    total = loadCost || total || "0.00";


    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {
                  text: "Shipper  Referance: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: shipref + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }]
            },
            {
              columns: [
                {
                  text: "Commodity: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: commodity + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Total Weight: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: weight + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            }, {
              columns: [
                {
                  text: "Equipment Type: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: EqType + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                },
              ]
            }, {
              columns: [
                {
                  text: "Distance: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: distance + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            }
          ],
          alignment: 'left',
        },
        {
          stack: [
            {
              columns: [
                {
                  text: "Payment Terms: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: terms + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Rate Qualifier: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: rateQualifer + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Rate: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: Number(rate) + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Total: ",
                  width: '*',
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: getCurrency(Number(total)) + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            //   {
            //     text: "Payment Terms: ",
            //     width: '*',
            //     fontSize: 12,
            //     bold: true,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            //   {
            //     text: terms + "\n",
            //     width: '*',
            //     fontSize: 12,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            //   {
            //     text: "Rate Qualifier: ",
            //     width: '*',
            //     fontSize: 12,
            //     bold: true,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            //   {
            //     text: rateQualifer + "\n",
            //     width: '*',
            //     fontSize: 12,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            //   {
            //     text: "Rate: ",
            //     width: '*',
            //     fontSize: 12,
            //     bold: true,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            //   {
            //     text: rate + "\n",
            //     width: '*',
            //     fontSize: 12,
            //     font: "Poppins",
            //     alignment: 'left'
            //   },
            // //   {
            // //     text: "Price: ",
            // //     width: '*',
            // //     fontSize: 12,
            // //     bold: true,
            // //     font: "Poppins",
            // //     alignment: 'left'
            // //   }
            // // ,
            // //   {
            // //     text: price + "\n",
            // //     width: '*',
            // //     fontSize: 12,
            // //     font: "Poppins",
            // //     alignment: 'left'
            // //   },
            //   {
            //     text: "Total: ",
            //     width: '*',
            //     fontSize: 12,
            //     bold: true,
            //     font: "Poppins",
            //     alignment: 'left'
            //   }
            // ,
            //   {
            //     text: total + "\n",
            //     width: '*',
            //     fontSize: 12,
            //     font: "Poppins",
            //     alignment: 'left'
            //   }
          ],
          alignment: 'right',
        }
      ]

    }
  }
  async generateJobPDFForApproval(pdfData) {

    const { invoiceHeader, invoiceItemsData, widths, total = 0, terms, bill = "Receipt" } = pdfData;
    const { pickupAddress, dropoffAddress, surcharge } = invoiceHeader;
    console.log({ pickupAddress, dropoffAddress });
    let cleanText = DOMPurify.sanitize(terms)
    let htmlText = htmlToPdfmake(cleanText)
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);

    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);

    const header2 = this.getHeader2("ESTIMATE", invoiceHeader.jobNumber, invoiceHeader.createdAt, "Estimate No");

    const shippingInfo = this.getShippingInfo("Estimate", invoiceHeader.customer, invoiceHeader.customerAddress);

    const pickupDropoffInfo = this.getPickupDropoffAddress(pickupAddress, dropoffAddress);

    const surchargeAmount = total * surcharge / 100;
    const surChargeData = this.getSurchargePart(surcharge, surchargeAmount);

    const summaryData = this.getSummaryPart(total + surchargeAmount);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      header: headerData,
      content: [


        '\n\n',

        header2,

        "\n",

        shippingInfo,

        // "\n",

        // pickupDropoffInfo,

        "\n",



        {

          table: {

            headerRows: 1,

            widths: widths,
            body: invoiceItemsData.slice(0, lineItemStart),
          },

          layout: this.tableLayout





        },

        // "\n\n",

        // surChargeData,

        "\n\n",

        summaryData,

        "\n\n",
        htmlText,

      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],

      footer: footerData,

      defaultStyle: {

        font: "Poppins",

        fontSize: 10,

      },

    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",

        );
      }
      docDefinition.content.push(summaryData)
    }
    docDefinition.content.push(
      { text: '', pageBreak: 'after' },
      {
        image: localStorage.getItem('pdfImage'), // Replace with your background image URL
        width: 595, // Adjust the width to match your page size
        height: 842, // Adjust the height to match your page size
        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
      },
      "\n\n\n\n\n\n",
      {
        text: "Name : " + "\n\n",
        width: '*',
        fontSize: 14,
        font: "Poppins",
        margin: [10, 40, 0, 0],
        bold: true,
      },
      {
        text: "Signature : " + "\n\n",
        width: '*',
        fontSize: 14,
        font: "Poppins",
        margin: [10, 15, 0, 0],
        bold: true,
      },
      {
        text: "Date : " + "\n\n",
        width: '*',
        fontSize: 14,
        font: "Poppins",
        margin: [10, 15, 0, 0],
        bold: true,
      },
    )
    let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

      const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

      try {

        const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

        // console.log("pdfInBase64: ", base64Data);

        resolve(base64Data);

      } catch (error) {

        reject(error);

      }

    });
    return pdfInBase64;
  }
  getBase64FromPdfGenerator(pdfDocGenerator) {
    return new Promise<string>((resolve, reject) => {
      pdfDocGenerator.getBase64((base64Data) => {
        resolve(base64Data);
      });
    });
  }
  generateFactorPDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, subTotal = 0, tax, invoiceType = 'Job No', stampImage="" } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const shippingInfo = this.getShippingInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress);
    const summaryData = this.getSummaryPart(total);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,


        },
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},
        stampImage? {
          image: stampImage,
          width: 200,
          absolutePosition: { x: 40, y: 660 },
        } : {
          absolutePosition: { x: 40, y: 662 },
          table: {
            headerRows: 1,
            widths: [250, '*'],
            body: [
              [
                {
                  text: 'Please make the payment to:',
                  bold: true,
                  alignment: 'left',
                  color: 'red',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                }
              ],
              [

                {
                  text: invoiceHeader?.factor?.companyName,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.paymentIntructions,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.googleAddress?.fullAddress,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
            ],
            layout: {
              defaultBorder: true,
              hLineWidth: function (i, node) {
                return 1;
              },
              vLineWidth: function (i, node) {
                return 1;
              },
              hLineColor: function (i, node) {
                return '#eaeaea';
              },
              vLineColor: function (i, node) {
                return '#eaeaea';
              },
              hLineStyle: function (i, node) {
                return null;
              },
              paddingLeft: function (i, node) {
                return 10;
              },
              paddingRight: function (i, node) {
                return 10;
              },
              paddingTop: function (i, node) {
                return 3;
              },
              paddingBottom: function (i, node) {
                return 3;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
          },
        }
      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(summaryData)
    }
    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
  }
  async generateFactorSendPDF(pdfData) {
    const { invoiceHeader, invoiceItemsData, widths, total = 0, subTotal = 0, tax, invoiceType = 'Job No', stampImage ="" } = pdfData;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const shippingInfo = this.getShippingInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress);
    const summaryData = this.getSummaryPart(total);
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      content: [
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,


        },
        "\n\n",
        invoiceItemsData.length <= lineItemStart ? summaryData : {},
        stampImage? {
          image: stampImage,
          width: 200,
          absolutePosition: { x: 40, y: 660 },
        } : {
          absolutePosition: { x: 40, y: 675 },
          table: {
            headerRows: 1,
            widths: [250, '*'],
            body: [
              [

                {
                  text: 'Please make the payment to:',
                  bold: true,
                  alignment: 'left',
                  color: 'red',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                }
              ],
              [

                {
                  text: invoiceHeader?.factor?.companyName,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.paymentIntructions,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.googleAddress?.fullAddress,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
            ],
            layout: {
              defaultBorder: true,
              hLineWidth: function (i, node) {
                return 1;
              },
              vLineWidth: function (i, node) {
                return 1;
              },
              hLineColor: function (i, node) {
                return '#eaeaea';
              },
              vLineColor: function (i, node) {
                return '#eaeaea';
              },
              hLineStyle: function (i, node) {
                return null;
              },
              paddingLeft: function (i, node) {
                return 10;
              },
              paddingRight: function (i, node) {
                return 10;
              },
              paddingTop: function (i, node) {
                return 3;
              },
              paddingBottom: function (i, node) {
                return 3;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
          },
        }
      ],
      pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    if (invoiceItemsData.length > lineItemStart) {
      for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
        let currentPageItems = [];
        currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
        docDefinition.content.push(
          { text: '', pageBreak: 'after' },
          {
            image: localStorage.getItem('pdfImage'), // Replace with your background image URL
            width: 595, // Adjust the width to match your page size
            height: 842, // Adjust the height to match your page size
            absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
          },
          headerData,
          "\n\n",
          {
            table: {
              headerRows: 0,
              widths: widths,
              body: currentPageItems,
            },
            layout: this.tableLayout,
          },
          "\n\n",
        );
      }
      docDefinition.content.push(summaryData)
    }
    let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {
      const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);
      try {
        const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);
        resolve(base64Data);

      } catch (error) {

        reject(error);

      }

    });
    return pdfInBase64
  }
  generateMultiplesPDFs(invoicesInfo) {
    console.log("invoicesInfo", invoicesInfo);
    let footerData = this.getFooterData(invoicesInfo[0].companyName, invoicesInfo[0].companyAddress, invoicesInfo.email);
    let dd: any = {
      content: [], pageMargins: [40, 20, 40, 60],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    for (let i = 0; i < invoicesInfo.length; i++) {
      // let {invoiceInfo, invoiceItemsData, total} = invoicesInfo[i];
      let { invoiceHeader, invoiceItemsData, widths, total = 0, subTotal = 0, tax, invoiceType = 'Job No' } = invoicesInfo[i];
      let headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
      let header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
      let shippingInfo = this.getShippingInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress);
      let summaryData = this.getSummaryPart(total);
      dd.content.push([
        {
          image: localStorage.getItem('pdfImage'), // Replace with your background image URL
          width: 595, // Adjust the width to match your page size
          height: 842, // Adjust the height to match your page size
          absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        },
        headerData,
        '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,


        },
        "\n\n",
        summaryData,
        "\n\n",
        invoiceHeader.invoiceAmount >= 0 ? {
          absolutePosition: { x: 40, y: 700 },
          table: {
            headerRows: 1,
            widths: [250, '*'],
            body: [
              [

                {
                  text: 'Please make the payment to:',
                  bold: true,
                  alignment: 'left',
                  color: 'red',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                }
              ],
              [

                {
                  text: invoiceHeader?.factor?.companyName,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.paymentIntructions,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
              [

                {
                  text: invoiceHeader?.factor?.googleAddress?.fullAddress,
                  bold: false,
                  color: 'red',
                  alignment: 'left',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 0, 0, 0],
                },
              ],
            ],
            layout: {
              defaultBorder: true,
              hLineWidth: function (i, node) {
                return 1;
              },
              vLineWidth: function (i, node) {
                return 1;
              },
              hLineColor: function (i, node) {
                return '#eaeaea';
              },
              vLineColor: function (i, node) {
                return '#eaeaea';
              },
              hLineStyle: function (i, node) {
                return null;
              },
              paddingLeft: function (i, node) {
                return 10;
              },
              paddingRight: function (i, node) {
                return 10;
              },
              paddingTop: function (i, node) {
                return 3;
              },
              paddingBottom: function (i, node) {
                return 3;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
          },
        } : {}
      ])

      if (i !== invoicesInfo.length - 1) {
        dd.content.push({ text: '', pageBreak: 'after' });
      }
    }
    pdfMake.createPdf(dd, null, null, pdfFonts1.pdfMake.vfs).open();

  }

  async generateJobStatementPDF(pdfData, preview, TnC?: any) {

    console.log("PDF DATA ==========================================");
    console.log(pdfData);

    const { loadDetails, loadsInfo, customer, widths, price, total = 0, rateQualifer, rate } = pdfData;
    let selectedCompanyId = localStorage.getItem('selectedCompany');
    let jobdetails = loadDetails[0].jobId
    let companyList = JSON.parse(sessionStorage.getItem('LOGIN_USER')).result[0].company

    let currentCompanyDetail = companyList.filter((company) => { return company.company._id == selectedCompanyId })[0].company;

    const footerData = this.getFooterData(currentCompanyDetail.name, loadDetails.companyAddress, currentCompanyDetail.email);

    const headerData = this.getStatementHeaderData(currentCompanyDetail.name, currentCompanyDetail.address.fullAddress);

    const header2 = this.getStatementHeader("DELIVERY STATEMENT", jobdetails.jobNumber, loadDetails[0].createdAt, "Load No");

    // const shippingInfo = this.getShippingInfo("Estimate", customer.name, customer.BillingAddress?.fullAddress | customer.CustomerAddress?.fullAddress);
    let equipType
    let table1: any = [
      [
        {
          text: 'load',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Driver',
          bold: true,
          width: 25,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Truck',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        // {
        //   text: 'Trailer',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [0, 5, 0, 5],
        //   rowSpan: 2,
        //   alignment: 'center'
        // },
        {
          text: 'Delivery Date',
          bold: true,
          width: 30,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Start',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Loading',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          colSpan: 2,
          alignment: 'center'
        }, {},
        {
          text: 'Unloading Address',
          bold: true,
          border: [true, true, true, true],
          rowSpan: 2,
          margin: [0, 5, 0, 5],
        },
        {
          text: 'Unloading',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          colSpan: 2,
          alignment: 'center'
        }, {},
        // {
        //   text: 'Unloading Depart',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [0, 5, 0, 5],
        // },
        {
          text: 'End',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Duration',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Material/Labor',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Weight tag',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Tons',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
        {
          text: 'Sign',
          bold: true,
          width: 40,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          rowSpan: 2,
          alignment: 'center'
        },
      ],
      [
        {},
        {},
        // {},
        {},
        {},
        {},
        {
          text: 'Arrive',
          bold: true,
          border: [true, true, true, true],
          margin: [5, 5, 0, 5],
          alignment: 'center'
        },
        // {
        //   text: 'Standby / Break Time',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [5, 5, 0, 5],
        //   alignment: 'center'
        // },
        // {
        //   text: 'Breakdown Time',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [5, 5, 0, 5],
        //   alignment: 'center'
        // },
        {
          text: 'Depart',
          bold: true,
          border: [true, true, true, true],
          margin: [5, 5, 0, 5],
          alignment: 'center'
        },
        {},
        {
          text: 'Arrive',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          alignment: 'center'
        },
        // {
        //   text: 'Standby / Break Time',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [5, 5, 0, 5],
        //   alignment: 'center'
        // },
        // {
        //   text: 'Breakdown Time',
        //   bold: true,
        //   border: [true, true, true, true],
        //   margin: [5, 5, 0, 5],
        //   alignment: 'center'
        // },
        {
          text: 'Depart',
          bold: true,
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          alignment: 'center'
        },
        {},
        {},
        {},
        {},
        {},
        {},
      ]
    ];
    let table2 :any= [];
    await loadDetails.forEach(load => {
      // obj.push(
      //   )
      const pickupArrive = this.getLastArrivedTime(load?.pickupInfo?.trackLoadStatus)?.dropoffDateTime ||
      this.getLastArrivedTime(load?.pickupInfo?.trackLoadStatus)?.updatedOn || '';
      const pickupDepart = this.getfirstDepartTime(load?.pickupInfo?.trackLoadStatus)?.dropoffDateTime ||
            this.getfirstDepartTime(load?.pickupInfo?.trackLoadStatus)?.updatedOn;
      const dropArrive = this.getLastArrivedTime(load?.dropOffInfo?.trackLoadStatus)?.dropoffDateTime ||
          this.getLastArrivedTime(load?.dropOffInfo?.trackLoadStatus)?.updatedOn || '';
      const dropDepart = this.getfirstDepartTime(load?.dropOffInfo?.trackLoadStatus)?.dropoffDateTime ||
          this.getfirstDepartTime(load?.dropOffInfo?.trackLoadStatus)?.updatedOn;

      const dropAddress = load?.dropOffInfo?.deliveredAddress?.fullAddress || jobdetails.jobTask[0]?.dropOffLocation?.fullAddress || ''
      const standByPickup =   (Number(load?.pickupInfo?.standByTime) || 0)
      const breakPickup =   (Number(load?.pickupInfo?.breakTime) || 0)
      const breakdownPickup =   (Number(load?.pickupInfo?.breakDownTime) || 0)
      const standByDrop = (Number(load?.dropOffInfo?.standByTime) || 0)
      const breakDrop = (Number(load?.dropOffInfo?.breakTime) || 0)
      const breakdownDrop = (Number(load?.dropOffInfo?.breakDownTime) || 0)
      let loadData = loadsInfo.find((l) => l?._id == load?.loadId?._id);
      let row: any =
        [
          {
            text: loadData?.loadNumber,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: load?.driver1?.fullName,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: load?.truck?.truckUnitNumber,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          // {
          //   text: 'TR1234',
          //   border: [true, true, true, true],
          //   margin: [0, 5, 0, 5],
          //   alignment: 'center'
          // },
          {
            text: this.getDateFormat(loadData?.actualLoadStartDateTime),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.get12HrTime(loadData?.actualLoadStartDateTime),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.getDateTime(pickupArrive),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          // {
          //   text: (standByPickup!= 0 ?(standByPickup +' Hrs') : '-' ) + ' / ' + (breakPickup!= 0 ?(breakPickup +' Hrs') : '-')   ,// standby time
          //   border: [true, true, true, true],
          //   margin: [0, 5, 0, 5],
          //   alignment: 'center'
          // },
          // {
          //   text: (breakdownPickup!= 0 ?(breakdownPickup +' Hrs') : '-' ) ,
          //   border: [true, true, true, true],
          //   margin: [0, 5, 0, 5],
          //   alignment: 'center'
          // },
          {
            text: this.getDateTime(pickupDepart),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: dropAddress,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.getDateTime(dropArrive),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          // {
          //   text: (standByDrop!= 0 ?(standByDrop +' Hrs') : '-')+ ' / ' + (breakDrop!= 0 ?(breakDrop +' Hrs') : '-'),
          //   border: [true, true, true, true],
          //   margin: [0, 5, 0, 5],
          //   alignment: 'center'
          // },
          // {
          //   text: (breakdownDrop!= 0 ?(breakdownDrop +' Hrs') : '-'),
          //   border: [true, true, true, true],
          //   margin: [0, 5, 0, 5],
          //   alignment: 'center'
          // },
          {
            text: this.getDateTime(dropDepart),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.get12HrTime(loadData?.actualLoadEndDateTime),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: load?.deliveredItemId?.timeOnLoad || load?.timeOnLoad,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.getItemWithName(load),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: loadData?.signature?.weightTagNumber,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
          {
            text: this.twoDecimals(loadData?.weight || (load.quantity < 0 ? -1* load.quantity : load.quantity)),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center'
          },
        ];
      if (loadData?.signature?.signatureImg) {
        row.push(
          {
            image: loadData?.signature?.signatureImg,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            alignment: 'center',
            width: 70,
            height: 30
          })
      } else {
        row.push({
          text: '',
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          alignment: 'center'
        })
      }
      table1.push(row)
      if(table2.findIndex(obj => load?.loadId?._id === obj.id) == -1 && load?.loadId?._id &&
      (standByPickup > 0 ||
      standByDrop > 0 ||
      breakPickup > 0 ||
      breakDrop > 0 ||
      breakdownPickup > 0 ||
      breakdownDrop > 0 )
      ){
        table2.push({
          id: load?.loadId?._id,
          loadNumber: loadData?.loadNumber,
          standByPickup: standByPickup,
          standByDrop: standByDrop,
          breakPickup: breakPickup,
          breakDrop: breakDrop,
          breakdownPickup: breakdownPickup,
          breakdownDrop: breakdownDrop,
          driver: load?.driver1?.fullName,

        })
      }
    });
    let timingTable =[
      [
        {
          text: "Load Number",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          rowSpan: 2,
          width: 90,
          alignment: 'center'
        },
        {
          text: "Driver",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          rowSpan: 2,
          width: 90,
          alignment: 'center'
        },
        {
          text: "Loading",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          colSpan:3,
          alignment: 'center'
        },
        {},{},
        {
          text: "Unloading",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          colSpan:3,
          alignment: 'center'
        },
        {},{}
      ],
      [
        {},
        {},
        {
          text: "Standby",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        },
        {
          text: "Break",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        },
        {
          text: "Breakdown",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        },
        {
          text: "Standby",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        },
        {
          text: "Break",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        },
        {
          text: "Breakdown",
          border: [true, true, true, true],
          margin: [0, 5, 0, 5],
          bold: true,
          width: 70,
          alignment: 'center'
        }
      ]
    ]
    if(table2.length>0){
      table2.forEach(element => {
        timingTable.push(
        [
          {
            text: element.loadNumber,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 90,
            alignment: 'center'
          },
          {
            text: element.driver,
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 90,
            alignment: 'center'
          },
          {
            text: (element.standByPickup!= 0 ?(element.standByPickup +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
          {
            text: (element.breakPickup!= 0 ?(element.breakPickup +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
          {
            text: (element.breakdownPickup!= 0 ?(element.breakdownPickup +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
          {
            text: (element.standByDrop!= 0 ?(element.standByDrop +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
          {
            text: (element.breakDrop!= 0 ?(element.breakDrop +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
          {
            text:  (element.breakdownDrop!= 0 ?(element.breakdownDrop +' Hrs') : '-'),
            border: [true, true, true, true],
            margin: [0, 5, 0, 5],
            bold: false,
            width: 70,
            alignment: 'center'
          },
      ]
    )
      });
    }
    // table1= table1+row
    if (loadDetails?.equipType == 0) {
      equipType = "Dry Van"
    } else if (loadDetails?.equipType == 1) {
      equipType = "Reefer"
    } else if (loadDetails?.equipType == 2) {
      equipType = "Flatbed"
    } else if (loadDetails?.equipType == 3) {
      equipType = "Stepdeck"
    } else if (loadDetails?.equipType == 4) {
      equipType = "Special"
    }
    else {
      equipType = ""
    }
    const consignSection = this.consignSection(jobdetails, loadDetails[0]?.dropOffInfo?.isInPlantCustomer, loadDetails[0]?.dropOffInfo?.deliveredTo);
    // const pickupDropoffInfo = this.getPickupDropoffRateconDetails2(pickDrop);

    // const surchargeAmount = total * surcharge / 100;
    // const surChargeData = this.getSurchargePart(surcharge, surchargeAmount) || '';

    // const summaryData = loadDetails.comments ? this.getRateconCommentsPart(loadDetails.comments) : "";
    let itemsPerPage = 6;
    let lineItemStart = 6;
    let cleanText = DOMPurify.sanitize(TnC)
    let htmlText = htmlToPdfmake(cleanText)
    const docDefinition: any = {
      pageOrientation: 'landscape',
      header: headerData,
      content: [

        // '\n\n',
        header2,
        "\n",
        consignSection,
        // "\n",
        // pickupDropoffInfo,
        "\n",
        // {
        {
          alignment: 'center',
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 2,
            body: table1,
            fontSize: 7
          },
        },
        "\n",
        // surChargeData,
        // table2.length>0 ?{
        //   text: "Timing: ",
        //   width: 100,
        //   fontSize: 12,
        //   bold: true,
        //   font: "Poppins",
        //   alignment: 'left'
        // }:'',
        table2.length>0 ?
        {
          alignment: 'center',
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 2,
            body: timingTable,
            fontSize: 7
          },
        }:'\n',
        "\n\n",
        // summaryData,
        htmlText
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 842, // Adjust the width to match your page size

        height: 595, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [20, 90, 20, 90],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 7,
      },
    };

    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (preview == true) {
      var win = window.open('', '_blank');
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open({},win );
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }

  getStatementHeaderData(companyName, companyAddress, title?) {
    return {
      columns: [
        {
          stack: [
            localStorage.getItem('companyLogo') ?
              {
                columns: [
                  {
                    image: localStorage.getItem('companyLogo'),
                    width: 80,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'center',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'center',
                    width: 180,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              } :
              {
                columns: [
                  {
                    text: '',
                    width: '*',
                    fontSize: 48,
                    alignment: 'center',
                    font: 'MyriadPro',
                    margin: [10, 25, 0, 0],
                  },
                  {
                    alignment: 'center',
                    width: 200,
                    margin: [10, 25, 0, 0],
                    text: [
                      {
                        text: companyName + "\n",
                        width: '*',
                        fontSize: 12,
                        font: "Poppins",
                        bold: true,
                        alignment: 'center', // Center align the company name
                        margin: [0, 25, 0, 0],  // Adjust top and bottom margin
                        fillColor: '#ff0000',
                      },
                      {
                        text: companyAddress + "\n",
                        width: '*',
                        fontSize: 9,
                        font: "Poppins",
                        alignment: 'center', // Center align the company address
                        margin: [0, 0, 0, 0],  // Adjust top and bottom margin
                      },
                    ],
                  },
                ]
              }
          ]
        }
      ]
    }
  }


  getStatementHeader(title, invoiceNumber, invoiceDate, isJOb?) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                  text: title.toUpperCase(),
                  width: '*',
                  fontSize: 28,
                  alignment: 'left',
                  font: 'MyriadPro',
                  margin: [0, 15, 0, 0],

                },
                {
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                  table: {
                    headerRows: 1,
                    widths: ['auto', '*'],
                    body: [
                      [
                        {
                          text: invoiceNumber ? "Job No" + ' # ' + invoiceNumber : '',
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [10, 5, 0, 5],
                        },
                        {
                          text: 'Date ' + moment(invoiceDate).format("MM/DD/YYYY"),
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                    ],
                  },
                }
              ]
            }
          ]
        }
      ]
    }
  }

  consignSection(job, isInPlantCustomer, loadConsignee: '') {

    let consigner = job.consignor || ""
    let consignee = loadConsignee || job.consignee || ""
    let customer = job.customer || ""
    let po = job.POReference || ""
    let orign = job.jobTask[0]?.pickUpLocation?.fullAddress || ''
    let destination = job.jobTask[0]?.dropOffLocation?.fullAddress || ''


    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {
                  text: "Customer: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: customer + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                },
              ]
            },
            {
              columns: [
                {
                  text: "Consignor: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: consigner + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }]
            },
            {
              columns: [
                {
                  text: "Origin: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: orign + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Inter-Plant Customer: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: isInPlantCustomer ? 'Yes' : 'No' + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'left',
        },
        {
          stack: [
            {
              columns: [
                {
                  text: "PO:",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: po + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Consignee: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: consignee + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Destination: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: destination + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'right',
        }
      ]

    }
  }
  getImageAsBase64(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(url, { responseType: 'blob' }).subscribe((blob: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data as string);
        };
        reader.onerror = () => {
          reject('Error occurred while reading the image.');
        };
        reader.readAsDataURL(blob);
      }, error => {
        reject('Error occurred while fetching the image.');
      });
    });
  }
  getDateFormat(dt) {
    if (dt) {
      let date = new Date(dt);
      return moment(date).format('MM/DD/YYYY')
    }
    return ''
  }
  get12HrTime(Time) {
    if (Time) {
      let date = new Date(Time);
      return moment(date).format("hh:mm A")
    }
    return ''
  }
  getDateTime(dt) {
    if (dt) {
      return moment(dt).format('MM/DD/YYYY hh:mm A')
    }
    return ''
  }
  consignJobInvSection(job) {

    let consigner = job.consignor
    let consignee = job.consignee
    let customer = job.customer
    let po = job.POReference
    let orign = job.jobTask[0]?.pickUpLocation?.fullAddress || ''
    let destination = job.jobTask[0]?.dropOffLocation?.fullAddress || ''


    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {
                  text: "Customer: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: customer + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                },
              ]
            },
            {
              columns: [
                {
                  text: "Consignor: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: consigner + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }]
            },
            {
              columns: [
                {
                  text: "Origin: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: orign + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'left',
        },
        {
          stack: [
            {
              columns: [
                {
                  text: "PO",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: po + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Consignee: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: consignee + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Destination: ",
                  width: 100,
                  fontSize: 12,
                  bold: true,
                  font: "Poppins",
                  alignment: 'left'
                },
                {
                  text: destination + "\n",
                  width: '*',
                  fontSize: 12,
                  font: "Poppins",
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'right',
        }
      ]

    }
  }


  async generateJobInvPDF(pdfData, preview = true) {
    const { invoiceHeader, invoiceItemsData, notes, widths, total = 0, subTotal = 0, tax, surcharge = 0, invoiceType = 'Job No' } = pdfData;
    let isInv = pdfData.isjobInv;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const header3 = this.getHeader3("SUMMARY", pdfData?.materialTotal, pdfData?.truckingTotal);
    const shippingInfo = await this.getShippingJobInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress, pdfData.jobid, pdfData.po, pdfData.consinor,pdfData.paymentTerms, notes);
    // const consinee = this.consignJobInvSection()
    const surchargeAmount = total * surcharge / 100;
    const surChargeData = this.getSurchargePart(surcharge, surchargeAmount);
    const summaryData = this.getSummaryPart(total );
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      header: headerData,
      content: [
        // {
        //   image: localStorage.getItem('pdfImage'), // Replace with your background image URL
        //   width: 595, // Adjust the width to match your page size
        //   height: 842, // Adjust the height to match your page size
        //   absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        // },
        // headerData,
        // '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,
        },
        // "\n\n",
        // surChargeData,
        "\n\n",
        summaryData,

        "\n\n",
        header3,

        // invoiceItemsData.length <= lineItemStart ? summaryData : {},
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    // if (invoiceItemsData.length > lineItemStart) {
    //   for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
    //     let currentPageItems = [];
    //     currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
    //     docDefinition.content.push(
    //       { text: '', pageBreak: 'after' },
    //       {
    //         image: localStorage.getItem('pdfImage'), // Replace with your background image URL
    //         width: 595, // Adjust the width to match your page size
    //         height: 842, // Adjust the height to match your page size
    //         absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
    //       },
    //       headerData,
    //       "\n\n",
    //       {
    //         table: {
    //           headerRows: 0,
    //           widths: widths,
    //           body: currentPageItems,
    //         },
    //         layout: this.tableLayout,
    //       },
    //       "\n\n",
    //     );
    //   }
    //   docDefinition.content.push(summaryData)
    // }
    if (preview) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }
  async generateJobTicketInvPDF(pdfData, preview = true) {
    const { invoiceHeader, invoiceItemsData, notes, widths, total = 0, subTotal = 0, tax, surcharge = 0, invoiceType = 'Job No' } = pdfData;
    let isInv = pdfData.isjobInv;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getHeaderData(invoiceHeader.companyName, invoiceHeader.companyAddress);
    const header2 = this.getHeader2("INVOICE", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType);
    const header3 = this.getHeader3("SUMMARY", pdfData?.materialTotal, pdfData?.truckingTotal);
    const shippingInfo = await this.getShippingJobInfo("Invoice", invoiceHeader.customerName, invoiceHeader.customerAddress, pdfData.jobid, pdfData.po, pdfData.consinor,invoiceHeader.paymentTerms, notes);
    // const consinee = this.consignJobInvSection()
    const surchargeAmount = total * surcharge / 100;
    const surChargeData = this.getSurchargePart(surcharge, surchargeAmount);
    const summaryData = this.getTicketInvoiceSummaryPart(pdfData );
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      header: headerData,
      content: [
        // {
        //   image: localStorage.getItem('pdfImage'), // Replace with your background image URL
        //   width: 595, // Adjust the width to match your page size
        //   height: 842, // Adjust the height to match your page size
        //   absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        // },
        // headerData,
        // '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,
        },
        // "\n\n",
        // surChargeData,
        "\n\n",
        summaryData,

        // invoiceItemsData.length <= lineItemStart ? summaryData : {},
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    // if (invoiceItemsData.length > lineItemStart) {
    //   for (let i = lineItemStart; i < invoiceItemsData.length; i += itemsPerPage) {
    //     let currentPageItems = [];
    //     currentPageItems = [...invoiceItemsData.slice(i, i + itemsPerPage)];
    //     docDefinition.content.push(
    //       { text: '', pageBreak: 'after' },
    //       {
    //         image: localStorage.getItem('pdfImage'), // Replace with your background image URL
    //         width: 595, // Adjust the width to match your page size
    //         height: 842, // Adjust the height to match your page size
    //         absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
    //       },
    //       headerData,
    //       "\n\n",
    //       {
    //         table: {
    //           headerRows: 0,
    //           widths: widths,
    //           body: currentPageItems,
    //         },
    //         layout: this.tableLayout,
    //       },
    //       "\n\n",
    //     );
    //   }
    //   docDefinition.content.push(summaryData)
    // }
    if (preview) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }
  async generateJobDispatch(pdfData, preview = true) {
    const { invoiceHeader, invoiceItemsData, notes, widths, total = 0, subTotal = 0, tax, surcharge = 0, invoiceType = 'Job No' } = pdfData;
    let isInv = pdfData.isjobInv;
    const footerData = this.getFooterData(invoiceHeader.companyName, invoiceHeader.companyAddress, invoiceHeader.email);
    const headerData = this.getDispatchHeaderData();
    const header2 = this.getHeader2("DISPATCH CONFIRMATION", invoiceHeader.invoiceId, invoiceHeader.invoiceDate ? invoiceHeader.invoiceDate : invoiceHeader.createdAt, invoiceType, 23);
    // const header3 = this.getHeader3("SUMMARY", pdfData?.materialTotal, pdfData?.truckingTotal);
    const shippingInfo = await this.getShippingJobDispatchInfo(invoiceHeader);
    // const consinee = this.consignJobInvSection()
    const surchargeAmount = total * surcharge / 100;
    const surChargeData = this.getSurchargePart(surcharge, surchargeAmount);
    const summaryData = this.getSummaryPart(total );
    let itemsPerPage = 6;
    let lineItemStart = 6;
    const docDefinition: any = {
      header: headerData,
      content: [
        // {
        //   image: localStorage.getItem('pdfImage'), // Replace with your background image URL
        //   width: 595, // Adjust the width to match your page size
        //   height: 842, // Adjust the height to match your page size
        //   absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner
        // },
        // headerData,
        // '\n\n',
        header2,
        "\n",
        shippingInfo,
        "\n",

        {
          table: {
            headerRows: 1,
            widths: widths,
            body: invoiceItemsData,
          },
          layout: this.tableLayout,
        },
        // "\n\n",
        // surChargeData,
        "\n\n",
        // summaryData,

        "\n\n",
        // header3,

        // invoiceItemsData.length <= lineItemStart ? summaryData : {},
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 10
      },
    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (preview) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }

  async getShippingTotalSummaryInfo(title, materialTotal) {

    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                },
                {
                  table: {
                    headerRows: 1,
                    widths: ['60%', '40%'],
                    body: [
                      [
                        {
                          text: `${title}:`,
                          fontSize: 12,
                          alignment: 'left',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: getCurrency(materialTotal || 0),
                          fontSize: 12,
                          alignment: 'right',
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ]
                    ],
                  },
                  layout: {
                    vLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                    hLineColor: function (i, node) {
                      if (i === node.table.body.length) {
                        return '#e5e5e5'; // Color for top and bottom borders
                      }
                    },
                  }
                }
              ]
            }
          ]
        }
      ]

    }

  }

  async getShippingJobInfo(invoiceToTitle, name, address, jobid, Po, consinor, paymentTerms , notes) {
    return {
      stack: [
        {
          columns: [
            {
              margin: [0, 0, 5, 0],
              table: {
                headerRows: 1,
                widths: ['100%'],
                body: [
                  [
                    {
                      text: `Bill To`,
                      fontSize: 12,
                      alignment: 'center',
                      bold: true,
                      border: [true, true, true, true],
                    }
                  ],
                  [
                    {
                      text: name ? name + "\n" : '' + "\n",
                      fontSize: 10,
                      alignment: 'left',
                      border: [true, true, true, false],
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: address ? address : '',
                      fontSize: 10,
                      alignment: 'left',
                      border: [true, false, true, true],
                    },
                  ]
                ],
              },
              layout: {
                vLineColor: function (i, node) {
                  if (i === node.table.body.length) {
                    return 'black'; // Color for top and bottom borders
                  }
                },
                hLineColor: function (i, node) {
                  if (i === node.table.body.length) {
                    return 'black'; // Color for top and bottom borders
                  }
                },
              }
            },
            {
              columns: [
                {
                  margin: [10, 5, 0, 0],
                  text: [
                    {
                      text: "Payment Terms" + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                      bold: true,
                    },
                    {
                      text: "PO" + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                      bold: true,
                    },
                    {
                      text: "Job #" + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                      bold: true,
                    },
                    {
                      text: "Consignor" + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                      bold: true,
                    },
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  text: [
                    {
                      text: paymentTerms ? paymentTerms + "\n" : " " + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                    },
                    {
                      text: Po + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                    },
                    {
                      text: jobid + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                    },
                    {
                      text: consinor + "\n",
                      width: '*',
                      fontSize: 10,
                      font: "Poppins",
                      alignment: 'left',
                    },
                  ]
                }
              ]
            }
          ]
        },
        {

          margin: [0, 10, 0, 0],
          table: {
            headerRows: 1,
            widths: ['100%'],
            body: [
              [
                {
                  text: `Notes`,
                  fontSize: 12,
                  alignment: 'center',
                  bold: true,
                  border: [true, true, true, true],
                }
              ],
              [
                {
                  text: notes || '\n\n\n',
                  fontSize: 10,
                  alignment: 'left',
                  margin: [0, 5, 0, 0],
                  border: [true, true, true, true],
                },
              ]
            ],
          },
          layout: {
            vLineColor: function (i, node) {
              if (i === node.table.body.length) {
                return 'black'; // Color for top and bottom borders
              }
            },
            hLineColor: function (i, node) {
              if (i === node.table.body.length) {
                return 'black'; // Color for top and bottom borders
              }
            },
          }

        }
      ]

    }
  }
async getShippingJobDispatchInfo(invoiceHeader) {
  return {
    stack: [
      {
        table: {
          widths: [85, '*', 'auto', '*'],
          body: [
            [
              { text: 'PO Reference:', bold: true, fontSize: 11},
              { text: invoiceHeader?.Po || '', fontSize: 11},
              { text: 'Origin:', bold: true, fontSize: 11},
              { text: invoiceHeader?.origin?.fullAddress || '', fontSize: 11}
            ],
            [
              { text: 'Item:', bold: true, fontSize: 11},
              { text: invoiceHeader?.items || '', fontSize: 11},
              { text: 'Delivery:', bold: true, fontSize: 11},
              { text: invoiceHeader?.destination?.fullAddress || '', fontSize: 11}
            ],
            [
              { text: 'Unit Type:', bold: true, fontSize: 11},
              { text: invoiceHeader?.unitType || '', fontSize: 11},
              { text: '',  border: [false, false, false, false] },
              { text: '',  border: [false, false, false, false] }
            ]
          ]
        },
        layout: {
          defaultBorder: false,
          // paddingTop: () => 5,
          // paddingBottom: () => 5,
        },
        margin: [0, 10, 0, 10]
      }
    ]
  };
}


   async generateJobTicketStatementPDF1(pdfData, preview, TnC?: any) {
    const tickets = pdfData?.tickets || [];
    const footerData = this.getFooterData("", "", "");

    const headerData = this.getDispatchHeaderData();

    const header2 = this.getTicketStatementHeader("DELIVERY STATEMENT", 1001, "05/15/2025");
    const driverTruckInfo = this.driverTruckInfoSection("John Doe", "", "Truck 123", "Trailer 456");
    const job = {
      customer: "XYZ Corporation",
      consignor: "ABC Logistics",
      consignee: "XYZ Corporation",
      POReference: "PO123456",
      jobTask: [
        {
          pickUpLocation: {
            fullAddress: "123 Main St, Anytown, USA 12345",
          },
          dropOffLocation: {
            fullAddress: "456 Elm St, Anytown, USA 12345",
          }
        }
      ]
    }
    const consignSection = this.consignJobTicketSection(job);
    // const shippingInfo = this.getShippingInfo("Estimate", customer.name, customer.BillingAddress?.fullAddress | customer.CustomerAddress?.fullAddress);
    let equipType
     let table1: any = [
       [
         {
           text: 'Loading',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           colSpan: 2,
           alignment: 'center'
         }, {},
         {
           text: 'Unloading',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           colSpan: 2,
           alignment: 'center'
         }, {},
         {
           text: 'Material/Labor',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           rowSpan: 2,
           alignment: 'center'
         },
         {
           text: 'Weight tag',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           rowSpan: 2,
           alignment: 'center'
         },
         {
           text: 'Tons',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           rowSpan: 2,
           alignment: 'center'
         },
         {
           text: 'Rate',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           rowSpan: 2,
           alignment: 'center'
         },
         {
           text: 'Amount',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           rowSpan: 2,
           alignment: 'center'
         },
       ],
       [
         {
           text: 'Arrive',
           bold: true,
           border: [true, true, true, true],
           margin: [5, 5, 0, 5],
           alignment: 'center'
         },
         {
           text: 'Depart',
           bold: true,
           border: [true, true, true, true],
           margin: [5, 5, 0, 5],
           alignment: 'center'
         },
         {
           text: 'Arrive',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           alignment: 'center'
         },
         {
           text: 'Depart',
           bold: true,
           border: [true, true, true, true],
           margin: [0, 5, 0, 5],
           alignment: 'center'
         },
         {},
         {},
         {},
         {},
         {}
       ],
       [
         { text: '08:00 AM', alignment: 'center', border: [true, true, true, true] },
         { text: '08:30 AM', alignment: 'center', border: [true, true, true, true] },
         { text: '09:00 AM', alignment: 'center', border: [true, true, true, true] },
         { text: '09:15 AM', alignment: 'center', border: [true, true, true, true] },
         { text: 'Gravel Delivery', alignment: 'left', border: [true, true, true, true] },
         { text: 'WT1234', alignment: 'center', border: [true, true, true, true] },
         { text: '10.5', alignment: 'center', border: [true, true, true, true] },
         { text: '$30', alignment: 'center', border: [true, true, true, true] },
         { text: '$315.00', alignment: 'right', border: [true, true, true, true] }
       ],
       [
        { text: '10:00 AM', alignment: 'center', border: [true, true, true, true] },
        { text: '10:20 AM', alignment: 'center', border: [true, true, true, true] },
        { text: '11:00 AM', alignment: 'center', border: [true, true, true, true] },
        { text: '11:15 AM', alignment: 'center', border: [true, true, true, true] },
        { text: 'Sand Delivery', alignment: 'left', border: [true, true, true, true] },
        { text: 'WT1235', alignment: 'center', border: [true, true, true, true] },
        { text: '8.0', alignment: 'center', border: [true, true, true, true] },
        { text: '$28', alignment: 'center', border: [true, true, true, true] },
        { text: '$224.00', alignment: 'right', border: [true, true, true, true] }
       ]
     ];
    let cleanText = DOMPurify.sanitize(TnC)
    let htmlText = htmlToPdfmake(cleanText)
    const docDefinition: any = {
      pageOrientation: 'landscape',
      header: headerData,
      content: [

        // '\n\n',
        header2,
        "\n",
        driverTruckInfo,
        "\n",
        consignSection,
        // "\n",
        // pickupDropoffInfo,
        "\n",
        // {
        {
          alignment: 'center',
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 2,
            widths: [ '*', '*', '*', '*', '*', '*', '*', '*', '*' ], // equal width for all column
            body: table1,
            fontSize: 7
          },
        },
        "\n",
        htmlText
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 842, // Adjust the width to match your page size

        height: 595, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [20, 90, 20, 90],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 7,
      },
    };

    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (preview == true) {
      var win = window.open('', '_blank');
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open({},win );
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          // console.log("pdfInBase64: ", base64Data);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }
async generateJobTicketStatementPDF(pdfData, preview, TnC?: any) {
  const tickets = pdfData?.tickets || [];
  const headerData = this.getDispatchHeaderData();
  const cleanText = DOMPurify.sanitize(TnC);
  const htmlText = htmlToPdfmake(cleanText);

  const signatureImages = tickets.map(t => t?.signature?.signatureImg || null);

  // Tracks which page each ticket starts on
  let ticketPageMap: number[] = [];
  let pageCounter = 1;

  const docDefinition: any = {
    pageOrientation: 'portrait',
    header: headerData,
    content: tickets.map((ticket, index) => {
      // console.log(ticket)
      const header2 = this.getTicketStatementHeader("", ticket?.ticketNumber, ticket?.givenStartDateTime);
      const driverTruckInfo = this.driverTruckInfoSection(ticket?.driver?.fullName, ticket?.carrier?.companyname, ticket?.truck?.truckUnitNumber, ticket?.trailer?.unitNumber);
      const consignSection = this.consignJobTicketSection(ticket);
      let totalAmount = 0;
      const tableBody = [
        [
          { text: 'Loading', bold: true, colSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] }, {},
          { text: 'Unloading', bold: true, colSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] }, {},
          { text: 'Material/Labor', bold: true, rowSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          { text: 'Weight tag', bold: true, rowSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          { text: 'Tons', bold: true, rowSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          // { text: 'Rate', bold: true, rowSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          // { text: 'Amount', bold: true, rowSpan: 2, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
        ],
        [
          { text: 'Arrive', bold: true, alignment: 'center', margin: [5, 5, 0, 5], border: [true, true, true, true] },
          { text: 'Depart', bold: true, alignment: 'center', margin: [5, 5, 0, 5], border: [true, true, true, true] },
          { text: 'Arrive', bold: true, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          { text: 'Depart', bold: true, alignment: 'center', margin: [0, 5, 0, 5], border: [true, true, true, true] },
          {}, {}, {}
          // , {}
        ],
      ];

      for (const load of ticket?.loads || []) {
        const selectedMetarial = ticket?.jobId?.jobTask?.find((task) => task?._id?.toString() === load?.material?.toString());
        const materialName = selectedMetarial ? selectedMetarial?.description : '';
        // const rate = selectedMetarial ? selectedMetarial?.rate : 0;
        // const amount = load?.actualWeight ? (load?.actualWeight * rate) : 0;
        // totalAmount += amount;
        tableBody.push([
          { text: load.loadingArrive? formatTime(load.loadingArrive) : '', bold: false, margin: [5, 5, 0, 5], alignment: 'center', border: [true, true, true, true] },
          { text: load?.loadingDepart ? formatTime(load.loadingDepart) : '', bold: false, margin: [5, 5, 0, 5], alignment: 'center', border: [true, true, true, true] },
          { text: load.unloadingArrive ? formatTime(load.unloadingArrive) : '', bold: false, margin: [5, 5, 0, 5], alignment: 'center', border: [true, true, true, true] },
          { text: load.unloadingDepart ? formatTime(load.unloadingDepart) : '' , bold: false, margin: [5, 5, 0, 5], alignment: 'center', border: [true, true, true, true] },
          { text: materialName || '', bold: false, margin: [5, 5, 0, 5], alignment: 'left', border: [true, true, true, true] },
          { text: load.weightTag || '', bold: false, margin: [5, 5, 0, 5], alignment: 'center', border: [true, true, true, true] },
          { text: load.actualWeight ? load.actualWeight.toFixed(2) : '', bold: false, margin: [5, 5, 0, 5], alignment: 'right', border: [true, true, true, true] },
          // { text: getCurrency(rate), bold: false, margin: [5, 5, 0, 5], alignment: 'right', border: [true, true, true, true] },
          // { text: getCurrency(amount), bold: false, margin: [5, 5, 0, 5], alignment: 'right', border: [true, true, true, true] }
        ]);
      }
      const surCharge = ticket?.salesTax || 0;
      // console.log("surcharge", surCharge);
      const surchargeAmount = totalAmount * Number(surCharge) / 100;
      // console.log("surchargeAmount", surchargeAmount);
      ticket.surchargeAmount = surchargeAmount;
      // totalAmount += surchargeAmount;
      totalAmount = ticket?.itemList ? Number(ticket?.itemList.reduce((accumulator, currentValue) => accumulator + Number(currentValue.amount), 0)) : 0;
      // let itemList = [];
      // if(!ticket?.itemList || ticket?.itemList.length == 0) {
      //   const jobTasks = ticket?.jobId?.jobTask || [];
      //   const jobTaskIds = ticket?.jobTaskIds || [];
      //   for (const task of jobTasks) {
      //     if (jobTaskIds.includes(task?._id?.toString())) {
      //       itemList.push(task);
      //     }
      //   }

      // }
      // for (let item of itemList) {
      //   let quantity = 0;
      //   if (item.costGroup == COST_GROUP.MATERIAL || item.costGroup == COST_GROUP.TONNAGE) {
      //     let weight = 0
      //     ticket?.loads.forEach((load) => {
      //       if (load.material === item._id) {
      //         weight = weight + load.actualWeight;
      //       }
      //     })
      //     item['quantity'] = item?.quantity ?? Number(weight.toFixed(2));
      //   }
      //   else if (item.costGroup == COST_GROUP.TRUCKING) {
      //     item['quantity'] = ticket?.chargeAbleTime || 0;
      //   }
      //   else if (item.costGroup == COST_GROUP.PERLOAD) {
      //     item['quantity'] = ticket.loads.length;
      //   }
      //   let qtyXrate = item['quantity'] * item['rate'];
      //   item['surChargeAmount'] = (qtyXrate * (item?.surCharge || 0) / 100)
      //   item['amount'] = (qtyXrate + Number(item['surChargeAmount']))
      // }
      // totalAmount = itemList ? Number(itemList.reduce((accumulator, currentValue) => accumulator + Number(currentValue.amount), 0)) : 0;
      // console.log("totalAmount", totalAmount);
      const summaryData = this.getTicketSummaryPart(ticket, totalAmount);

      const ticketContent = {
        stack: [
          ...(index > 0 ? [{ text: '', pageBreak: 'before' }] : []),
          header2,
          "\n",
          driverTruckInfo,
          "\n",
          consignSection,
          "\n",
          {
            alignment: 'center',
            margin: [0, 0, 0, 0],
            table: {
              headerRows: 2,
              widths: ['*', '*', '*', '*', 'auto', '*', '*'],
              body: tableBody
            }
          },
          "\n",
          ...(ticket.loads.length > 8
            ? [
                { text: '', pageBreak: 'before' },
                "\n",
                summaryData,
                "\n",
                htmlText
              ]
            : [
                "\n",
                summaryData,
                "\n",
                htmlText
              ])
        ]
      };

      ticketPageMap.push(pageCounter);
      const estimatedPages = ticket.loads.length > 8 ? 2 : 1;
      pageCounter += estimatedPages;

      return ticketContent;
    }),
    background: {
      image: localStorage.getItem('pdfImage'),
      width: 595,
      height: 842,
      absolutePosition: { x: 0, y: 0 }
    },
    pageMargins: [20, 90, 20, 90],
    footer: (currentPage, pageCount) => {
      let ticketIndex = 0;
      for (let i = 0; i < ticketPageMap.length; i++) {
        if (ticketPageMap[i] <= currentPage) {
          ticketIndex = i;
        }
      }

      const signature = signatureImages[ticketIndex];

      return {
        margin: [40, 0, 40, 20],
        columns: [
          {
            alignment: 'center',
            width: '40%',
            margin: [20, 0, 0, 0],
            stack: [
              {
                text: 'Signature of Consignee (or Agent)',
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 5]
              },
              signature
                ? { image: signature, width: 120, height: 50, alignment: 'center' }
                : { text: '' }
            ]
          },
          {},
          {
            alignment: 'right',
            width: '30%',
            fillColor: '#ff0000',
            margin: [0, 0, 10, 0],
            text: [
              {
                text: "Powered by \n",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true
              },
              {
                text: "LOADMILES",
                fontSize: 11,
                font: "Poppins",
                color: "white",
                bold: true,
                link: "http://www.loadmiles.com"
              }
            ]
          }
        ]
      };
    },
    defaultStyle: {
      font: "Poppins",
      fontSize: 7,
    }
  };

  docDefinition.header['margin'] = [0, 20, 40, 0];

  if (preview === true) {
    const win = window.open('', '_blank');
    pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open({}, win);
  } else {
    const pdfInBase64 = await new Promise<string>(async (resolve, reject) => {
      const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);
      try {
        const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);
        resolve(base64Data);
      } catch (error) {
        reject(error);
      }
    });
    return pdfInBase64;
  }
}



  getTicketStatementHeader(title, invoiceNumber, invoiceDate, isJOb?) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {

                  text: title.toUpperCase(),
                  width: '*',
                  fontSize: 28,
                  alignment: 'left',
                  font: 'MyriadPro',
                  margin: [0, 15, 0, 0],

                },
                {
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                  table: {
                    headerRows: 1,
                    widths: ['auto', '*'],
                    body: [
                      [
                        {
                          text: invoiceNumber ? "Ticket No" + ' # ' + invoiceNumber : '',
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [10, 5, 0, 5],
                        },
                        {
                          text: 'Date ' + moment(invoiceDate).format("MM/DD/YYYY"),
                          style: this.InvoiceCustomStyle,
                          border: [false, false, false, false],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                    ],
                  },
                }
              ]
            }
          ]
        }
      ]
    }
  }
   consignJobTicketSection(ticket) {
    let job = ticket?.jobId || {}
    let consigner = job?.consignor || ''
    let consignee = job?.consignee || ''
    let customer = job?.customer || ''
    let po = job?.POReference
    let orign =  ticket?.origin;
    let destination = ticket?.destination;


    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {
                  text: "Customer: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: customer + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                },
              ]
            },
            {
              columns: [
                {
                  text: "Consignor: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: consigner + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }]
            },
            {
              columns: [
                {
                  text: "Origin: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: orign + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'left',
        },
        {
          stack: [
            {
              columns: [
                {
                  text: "PO:",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: po + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Consignee: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: consignee + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Destination: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: destination + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
          ],
          alignment: 'right',
        }
      ]

    }
  }
  driverTruckInfoSection(driverName, carrierName, truckNumber, trailerNumber) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                {
                  text: driverName ? "Driver: " : "Carrier: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: `${driverName ? driverName : carrierName }` + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Truck: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: `${truckNumber || ""}` + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            },
            {
              columns: [
                {
                  text: "Trailer: ",
                  width: 100,
                  fontSize: 11,
                  bold: true,
                  alignment: 'left'
                },
                {
                  text: `${trailerNumber || ""}` + "\n",
                  width: '*',
                  fontSize: 11,
                  alignment: 'left'
                }
              ]
            }
          ],
        }
      ]
    }
  }
 getJobTicketFooterData(signature?) {
  console.log("signature: ", signature);
  return {
    columns: [
      {
        alignment: 'center',
        width: '40%',
        margin: [20, 0, 0, 0],
        stack: [
          {
            text: 'Signature of Consignee or Agent',
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          signature ? {
            image: signature,  // This should be a base64 string like 'data:image/png;base64,...'
            width: 120,
            height: 50,
            alignment: 'center',
            margin: [0, 0, 0, 0]
          } : {
            text: ''
          }
        ]
      },
      {},
      localStorage.getItem('companyLogo') ? {
        alignment: 'right',
        width: '30%',
        fillColor: '#ff0000',
        text: [
          {
            text: "Powered by \n",
            fontSize: 11,
            font: "Poppins",
            color: "white",
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0],
          },
          {
            text: "LOADMILES",
            fontSize: 11,
            font: "Poppins",
            color: "white",
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0],
            link: "http://www.loadmiles.com"
          }
        ]
      } : {
        alignment: 'right',
        width: '30%',
        fillColor: '#ff0000',
        margin: [0, 0, 10, 0],
        text: [
          {
            text: "Powered by \n",
            fontSize: 11,
            font: "Poppins",
            color: "white",
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0],
          },
          {
            text: "LOADMILES",
            fontSize: 11,
            font: "Poppins",
            color: "white",
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 0],
            link: "http://www.loadmiles.com"
          }
        ]
      }
    ]
  };
}
getTicketSummaryPart(ticket, totalAmount) {
  return {
    columns: [
      { width: '40%', text: '' },
      {
        width: '60%',
        table: {
          headerRows: 0,
          widths: ['*', '*', '*', '*'],
          body: [
            [
              {
                text: 'Trip Time',
                fontSize: 8,
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: ticket?.totalTripTime ? ticket.totalTripTime.toLocaleString(2) : '',
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: 'Chargeable Time',
                fontSize: 8,
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: ticket?.chargeAbleTime ? ticket.chargeAbleTime.toLocaleString(2) : '',
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              }
            ],
            [
              {
                text: 'Standby Time',
                fontSize: 8,
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: ticket?.standByTime ? ticket.standByTime.toLocaleString(2) : '',
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: 'Break Time',
                fontSize: 8,
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: ticket?.breakTime ? ticket.breakTime.toLocaleString(2) : '',
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              }
            ],
            [
              {
                text: 'Breakdown Time',
                fontSize: 8,
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: ticket?.breakdownTime ? ticket.breakdownTime.toLocaleString(2) : '',
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: 'Total Amount',
                fontSize: 8,
                bold: true,
                fillColor: '#f2f2f2',
                alignment: 'left',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              },
              {
                text: getCurrency(totalAmount),
                fontSize: 8,
                alignment: 'right',
                border: [true, true, true, true],
                margin: [0, 5, 0, 5],
              }
            ]
          ]
        }
      }
    ]
  };
}

 getTicketInvoiceSummaryPart(pdfData) {
    return {
      columns: [
        {
          stack: [
            {
              columns: [
                // {

                // },
                {

                },
                {
                  table: {
                    headerRows: 1,
                    widths: ['*', '*'],
                    body: [
                      [
                        {
                          text: 'Sub Total',
                          fontSize: 10,
                          bold:true,
                          alignment: 'left',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                          fillColor: '#f2f2f2',
                        },
                        {
                          text: getCurrency(pdfData?.subTotal),
                          fontSize: 10,
                          alignment: 'right',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                      [
                        {
                          text: `Sales Tax (${pdfData?.salesTax}%)`,
                          fontSize: 10,
                          bold:true,
                          alignment: 'left',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                          fillColor: '#f2f2f2',
                        },
                        {
                          text: getCurrency(pdfData?.salesTaxAmount),
                          fontSize: 10,
                          alignment: 'right',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                        },
                      ],
                      [
                        {
                          text: 'Net To Pay',
                          fontSize: 10,
                          bold:true,
                          alignment: 'left',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                          fillColor: '#f2f2f2',
                        },
                        {
                          text: getCurrency(pdfData?.invoiceAmount),
                          fontSize: 10,
                          alignment: 'right',
                          border: [true, true, true, true],
                          margin: [0, 5, 0, 5],
                        },
                      ]
                    ],
                  },
                  // layout: {
                  //   vLineColor: function (i, node) {
                  //     if (i === node.table.body.length) {
                  //       return '#e5e5e5'; // Color for top and bottom borders
                  //     }
                  //   },
                  //   hLineColor: function (i, node) {
                  //     if (i === node.table.body.length) {
                  //       return '#e5e5e5'; // Color for top and bottom borders
                  //     }
                  //   },
                  // }
                }
              ]
            }
          ]
        }
      ]

    }
  }
  twoDecimals(num) {
    return Number(num).toFixed(2) || null
  }
  getItemWithName(rowData) {
    // if (rowData.deliveryDate) {
    //   let returnItems = "";
    //   rowData.invoicesWithStatus[rowData.invoicesWithStatus.length - 1].invoiceLineItems.map(data => {
    //     returnItems = returnItems + data.item + " - " + data.description + " , ";
    //   });
    //   return returnItems.substring(0, returnItems.length - 2);

    // } else {
      return rowData.item + " - " + rowData.description;
    // }
  }



  async customerReportPDF(pdfData, preview = true) {
    let customer = pdfData.customer;
    let jobSales = pdfData.jobSales;
    let arAging = pdfData.arAging;
    let total_amount = pdfData.total
    const footerData = this.getFooterData(customer.name, customer.CustomerAddress?.fullAddress || '');
    const headerData = this.getHeaderData(customer.name, customer.CustomerAddress?.fullAddress || '');

    const docDefinition: any = {
      header: headerData,
      content: [
        "\n",
        {
          table: {
            headerRows: 1,
            body: arAging,
            fillOpacity: 0,
            widths: ['*', '*', '*', '*', '*'],
          },
          layout: this.tableLayout,
        },
        "\n",
        {
          table: {
            widths: [60, 40, 50, '*', '*', '*', '*'],
            headerRows: 1,
            body: jobSales,
            fillOpacity: 0
          },
          layout: this.tableLayout,
        },
        "\n\n",
        {
          columns: [
            {
              stack: [
                {
                  columns: [
                    {

                    },
                    {
                      table: {
                        headerRows: 1,
                        widths: ['60%', '40%'],
                        body: [
                          [
                            {
                              text: `Total:`,
                              fontSize: 12,
                              alignment: 'left',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                            {
                              text: getCurrency(total_amount || 0),
                              fontSize: 12,
                              alignment: 'right',
                              border: [false, false, false, false],
                              margin: [0, 5, 0, 5],
                            },
                          ]
                        ],
                      },
                      layout: {
                        vLineColor: function (i, node) {
                          if (i === node.table.body.length) {
                            return '#e5e5e5'; // Color for top and bottom borders
                          }
                        },
                        hLineColor: function (i, node) {
                          if (i === node.table.body.length) {
                            return '#e5e5e5'; // Color for top and bottom borders
                          }
                        },
                      }
                    }
                  ]
                }
              ]
            }
          ]

        }
        // invoiceItemsData.length <= lineItemStart ? summaryData : {},
      ],
      background:
      {

        image: localStorage.getItem('pdfImage'), // Replace with your background image URL

        width: 595, // Adjust the width to match your page size

        height: 842, // Adjust the height to match your page size

        absolutePosition: { x: 0, y: 0 }, // Position the image at the top-left corner

      },
      pageMargins: [40, 110, 40, 110],
      footer: footerData,
      defaultStyle: {
        font: "Poppins",
        fontSize: 9
      },
    };
    docDefinition.header['margin'] = [0, 20, 40, 0]
    docDefinition.footer['margin'] = [0, 30, 0, 0]
    if (preview) {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs).open();
    }
    else {
      let pdfInBase64 = await new Promise<string>(async (resolve, reject) => {

        const pdfDocGenerator = pdfMake.createPdf(docDefinition, null, null, pdfFonts1.pdfMake.vfs);

        try {

          const base64Data = await this.getBase64FromPdfGenerator(pdfDocGenerator);

          resolve(base64Data);

        } catch (error) {

          reject(error);

        }

      });
      return pdfInBase64;
    }
  }
  getLastArrivedTime(trackLoadStatus) {
    if(trackLoadStatus){
      let arr_status = trackLoadStatus.filter(obj => {
        if (obj.loadStatus == '3') {
          return obj
        }
      })
      return arr_status[arr_status.length - 1]
    }
    return null
  }
  getfirstDepartTime(trackLoadStatus) {
    if(trackLoadStatus){
      let arr_status = trackLoadStatus.filter(obj => {
        if (obj.loadStatus == '1') {
          return obj
        }
      })
      return arr_status[0]
    }
    return null
  }
  loadLocalImageAsBase64(imagePath: string): Promise<string> {
    return this.http.get(imagePath, { responseType: 'blob' }).toPromise().then(blob => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
  }

}
